/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetChildrenQueryResponse, HierarchiesControllerGetChildrenPathParams, HierarchiesControllerGetChildrenQueryParams, HierarchiesControllerGetChildren401, HierarchiesControllerGetChildren403 } from "../../models/hierarchiesController/HierarchiesControllerGetChildren";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetChildren } from "../../clients/hierarchiesService/hierarchiesControllerGetChildren";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetChildrenQueryKey = (scopeId: HierarchiesControllerGetChildrenPathParams["scopeId"], params: HierarchiesControllerGetChildrenQueryParams = {}) => [{
  url: '/api/v1/hierarchies/:scopeId/children',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetChildrenQueryKey = ReturnType<typeof hierarchiesControllerGetChildrenQueryKey>;
export function hierarchiesControllerGetChildrenQueryOptions(scopeId: HierarchiesControllerGetChildrenPathParams["scopeId"], params?: HierarchiesControllerGetChildrenQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetChildrenQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetChildrenQueryResponse, ResponseErrorConfig<HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403>, HierarchiesControllerGetChildrenQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetChildren(scopeId, params, config);
    }
  });
}

/**
 * @description Retrieve immediate child scopes of a given scope. Supports filtering by scope type(s) using comma-separated values (e.g., scopeType=FILE,FOLDER)
 * @summary Get child scopes
 * {@link /api/v1/hierarchies/:scopeId/children}
 */
export function useHierarchiesControllerGetChildren<TData = HierarchiesControllerGetChildrenQueryResponse, TQueryData = HierarchiesControllerGetChildrenQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetChildrenQueryKey>(scopeId: HierarchiesControllerGetChildrenPathParams["scopeId"], params?: HierarchiesControllerGetChildrenQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetChildrenQueryResponse, ResponseErrorConfig<HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetChildrenQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetChildrenQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}